import * as React from "react";
import {inject} from "mobx-react";
import classnames from "classnames";

import {ButtonInline} from "@ok/common/design-system/components/ButtonInline";
import {BottomSheet} from "@ok/web/components/base/BottomSheet/BottomSheet";
import { copy as copyTextToClipboard } from "@ok/web/utils/clipboard";
import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";
import {ButtonCellActionCopyLink, ButtonCellActionBlock, ButtonCellAction} from "@ok/common/design-system";
import {AnonymControlWrapper} from "../../common/controls/AnonymControlWrapper";
import {ToastType} from "../../../../lib/types";
import {l10n} from "@ok/web/modules/l10n/l10n";
import classes from "../Clip.styl";

const l10NPkg = l10n("clips");

interface IMore {
    store?: ClipsFullscreenStore;
    complaintLink: string;
}

export const More: React.FC<IMore> = inject("store")(
    (props): React.ReactElement => {
        const store = props.store!;

        const [isBottomSheetOpen, setIsBottomSheetOpen] = React.useState(false);

        const handleCopyLink = React.useCallback(() => {
            copyTextToClipboard(store.getLinkOnCurrentClip1())
                .then(() => {
                    setIsBottomSheetOpen(false);

                    store.setShowToast(ToastType.LINK_COPIED);
                });
        }, [store]);


        return (
            <>
                <ButtonInline
                    data-tsid={" "}
                    size={"32"}
                    view={"primary-on-color"}
                    aria-label={"more"}
                    onClick={() => {
                        setIsBottomSheetOpen(true);
                    }}
                >
                    <ButtonInline.LeftIcon
                        icon={"glyph_more_24+"}
                    />
                </ButtonInline>

                <BottomSheet
                    withPadding={true}
                    withSwipeBar={false}
                    open={isBottomSheetOpen}
                    portalClassName={"clips-fullscreen"}
                    onClose={() => {
                        setIsBottomSheetOpen(false);
                    }}

                >
                    <ButtonCellActionCopyLink label={l10NPkg.getLMsg("copyLiknk")} onClick={handleCopyLink}/>
                    {(store.isAnonym && store.returnUrl) ?
                        <AnonymControlWrapper>
                            <ButtonCellActionBlock label={l10NPkg.getLMsg("report")}/>
                        </AnonymControlWrapper>
                        :
                        <a href={props.complaintLink}
                           data-view={"bottomMenuComplaints"}
                           className={classnames("js-nav-same-page", classes["complaint-link"])}
                           data-bmenu-xhr={props.complaintLink}
                           data-bmenu-height={"400"}
                           data-bmenu-title={l10NPkg.getLMsg("report")}
                           data-func={"show"}>
                            <ButtonCellAction
                                view={"secondary"}
                            >
                                <ButtonCellAction.LeftIcon icon="glyph_alert_circle_24+"/>
                                <ButtonCellAction.Label>
                                    {l10NPkg.getLMsg("report")}
                                </ButtonCellAction.Label>
                            </ButtonCellAction>
                        </a>}
                </BottomSheet>
            </>
        );
    }
);
